import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { loadScriptInDomNode } from '../../utils/dom';

export default class SpotIMContainer extends Component {
  componentDidMount() {
    window.SPOTIM = window.SPOTIM || {
      spotId: this.props.spotID,
      options: { newsfeed: false }
    };

    /*
     * Spot.IM does not work if you use `loadScriptInHead` like all
     * of our other beacons. It must be inserted into this component's
     * dom element.
     */
    loadScriptInDomNode(
      'necessary', this.props.scriptURL, this._node, this.props.scriptOptions
    );
  }

  shouldComponentUpdate(nextProps) {
    return this.props.renderID !== nextProps.renderID;
  }

  componentDidUpdate() {
    while (this._node.firstChild) {
      this._node.removeChild(this._node.firstChild);
    }

    loadScriptInDomNode(
      'necessary', this.props.scriptURL, this._node, this.props.scriptOptions
    );
  }

  render() {
    return (
      <div className={this.props.className}
        id={this.props.id}
        onClick={this.props.handleClick}
        ref={element => this._node = element}
        dangerouslySetInnerHTML={{ __html: this.props.html }}
      />
    );
  }
}

SpotIMContainer.propTypes = {
  id: PropTypes.string,
  renderID: PropTypes.any.isRequired,
  className: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  html: PropTypes.string,
  spotID: PropTypes.string.isRequired,
  scriptURL: PropTypes.string.isRequired,
  scriptOptions: PropTypes.shape({
    async: PropTypes.bool,
    attrs: PropTypes.object
  })
};
